import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = '页面不存在 - 长日光阴';
  }, []);

  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center px-4 py-20 text-center">
      <span className="font-heading text-7xl font-black text-background-200 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">没有找到这个页面</h1>
      <p className="mt-2 font-mono text-sm text-secondary-500">{location.pathname}</p>
      <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">
        页面可能已经被移动或不存在。不如回到首页，或去分类页发现一部新作品。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}